import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import ACCOUNT_PLANS from '../config/accountPlans';

const GatedRoute = ({ element: Element, requiredFeature, ...rest }) => {
    const { user } = useSelector((state) => state.auth);

    // Normalize accountType
    const accountType = (user?.accountType || 'free').toLowerCase();
    const plan = ACCOUNT_PLANS[accountType] || ACCOUNT_PLANS.free;

    // Check if the feature is enabled for this plan
    const isAllowed = plan.features ? plan.features[requiredFeature] !== false : true;

    if (!isAllowed) {
        // Redirect to pricing page
        return <Navigate to="/dashboard/pricing" replace />;
    }

    return typeof Element === 'function' ? <Element {...rest} /> : Element;
};

export default GatedRoute;
